import RequestDocumentData from 'Data/RequestDocumentData';
import ServiceContractDetailsDocumentData from 'Data/ServiceContractDetailsDocumentData';
import ServiceContractDocumentData from 'Data/ServiceContractDocumentData';
import { del, post } from 'Data/SystemREST';
import TransactionDocumentData from 'Data/TransactionDocumentData';
import GenericTableData from './GenericTableData';

// Document Module Event Bus.
let DocumentData = GenericTableData.getTableDataBus('DOC', 'documents');

DocumentData.uploadDocument = (file, docObject = {}) => {
  let requestURL = `filer`;
  return post(requestURL)
    .field('documentObject', JSON.stringify(docObject))
    .attach('file', file)
    .then((res) => {
      const payload = res.body;
      DocumentData.notifyListeners('DOCUMENT_UPLOADED', payload.document);
      return payload.document;
    })
    .catch((err) => {
      DocumentData.notifyListeners('DOCUMENT_UPLOAD_ERROR', {
        message: `Unable to upload document ${file.name}: ${err}`,
      });
      console.log(err);
      throw err;
    });
};

DocumentData.uploadRequestDocument = (file, requestId) => {
  return DocumentData.uploadDocument(file)
    .then((savedDoc) => {
      return RequestDocumentData.createRecord({
        document_id: savedDoc.id,
        request_id: requestId,
      });
    })
    .catch((err) => {
      DocumentData.notifyListeners('DOCUMENT_UPLOAD_ERROR', {
        message: `Unable to upload document ${file.name} to Request ${requestId}: ${err}`,
      });
      console.error(err);
    });
};

DocumentData.uploadTransactionDocument = (file, transactionId) => {
  return DocumentData.uploadDocument(file)
    .then((savedDoc) => {
      return TransactionDocumentData.createRecord({
        document_id: savedDoc.id,
        transaction_id: transactionId,
      });
    })
    .catch((err) => {
      DocumentData.notifyListeners('DOCUMENT_UPLOAD_ERROR', {
        message: `Unable to upload document ${file.name} to Transaction ${transactionId}: ${err}`,
      });
      console.error(err);
    });
};

DocumentData.uploadServiceContractDocument = (file, serviceContractId) => {
  return DocumentData.uploadDocument(file, { type: 'SERVICE_CONTRACT' })
    .then((savedDoc) => {
      return ServiceContractDocumentData.createRecord({
        document_id: savedDoc.id,
        service_contract_id: serviceContractId,
      });
    })
    .catch((err) => {
      DocumentData.notifyListeners('DOCUMENT_UPLOAD_ERROR', {
        message: `Unable to upload document ${file.name} to ServiceContractDetails ${serviceContractDetailsId}}: ${err}`,
      });
      console.error(err);
    });
};

DocumentData.uploadServiceContractDetailsDocument = (
  file,
  serviceContractDetailsId,
) => {
  return DocumentData.uploadDocument(file, { type: 'SERVICE_CONTRACT' })
    .then((savedDoc) => {
      return ServiceContractDetailsDocumentData.createRecord({
        document_id: savedDoc.id,
        service_contract_details_id: serviceContractDetailsId,
      });
    })
    .catch((err) => {
      DocumentData.notifyListeners('DOCUMENT_UPLOAD_ERROR', {
        message: `Unable to upload document ${file.name} to ServiceContractDetails ${serviceContractDetailsId}}: ${err}`,
      });
      console.error(err);
    });
};

DocumentData.deleteDocument = (docId) => {
  let requestURL = `api/documents/${docId}/file`;
  return del(requestURL)
    .then((res) => {
      const payload = res.body;
      DocumentData.notifyListeners('DOCUMENT_DELETED', payload);
      return payload;
    })
    .catch((err) => {
      DocumentData.notifyListeners('DOCUMENT_DELETE_ERROR', {
        message: `Unable to delete document : ${err}`,
      });
    });
};

export default DocumentData;
